// ── 출퇴근 관리 [엑셀 다운로드]·[시간 설정] 한 벌 (2026-09-29, AttendanceManagement 에서 분리) ─────
//   두 탭(달력·직원별 상세)이 **같은 버튼·같은 일**을 하게(사용자 확정 "같은 기능").
//   달력 탭에서 누르면 달력에서 보던 달 기준. 시간 설정 창·회사 고르기 창도 여기서 그린다(modals).
//   ips(IP 별칭 목록)를 안 받으면(달력 탭) 시간 설정을 열 때 한 번 불러온다 — 상세 탭(useAttendanceData)과 같은 주소
//   (통합 메뉴면 그 메뉴의 /ips, 그 외 /api/admin/ips — 고객사는 서버가 막아 빈 목록, 상세 탭과 같다).
import React, { useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { useToast } from '../../../components/Toast';
import { useTimeSettings } from './useTimeSettings';
import { TimeSettingsModalsArea } from './TimeSettingsModalsArea';
import { triggerAttendanceExcelDownload } from './attendanceExport';

export function useAttendanceTools({
  attendancePath = '/api/admin/attendance',
  companyCode = 'PINE',
  apiBasePath = '/api',
  companyCodes,
  selectedCompanyCodes,
  timeSettingsPathBuilder,
  ips,
} = {}) {
  const { showToast } = useToast();
  // 모달 상태: 시간설정 wrapper(C) — TimeSettingsModalsArea로 전달
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [activeSettingsCompany, setActiveSettingsCompany] = useState(null);
  const [pendingOpenSettings, setPendingOpenSettings] = useState(false);
  const [ownIps, setOwnIps] = useState(null);
  const selectedSettingsCompany = activeSettingsCompany || companyCode || 'PINE';
  const ts = useTimeSettings({
    showToast,
    companyCode: selectedSettingsCompany,
    apiBasePath: timeSettingsPathBuilder
      ? apiBasePath
      // 뷰어 자기 회사(companyCode: 운영자=PINE / 테넌트=자기 회사)는 메인 라우트(apiBasePath, Fix B 가 스코프).
      //   그 외(추가 외부회사)만 ext 라우트. 'PINE' 하드코딩 대신 뷰어 회사 기준으로 비교.
      : selectedSettingsCompany && selectedSettingsCompany !== companyCode
        ? `/api/admin/ext/${selectedSettingsCompany}`
        : apiBasePath,
    settingsPathBuilder: timeSettingsPathBuilder,
  });
  useEffect(() => {
    if (pendingOpenSettings) { ts.openTimeSettingsModal(); setPendingOpenSettings(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSettingsCompany, pendingOpenSettings]);

  // 엑셀 다운로드 — nameQuery 전달 시 시프티 매트릭스(시나리오 A) 분기 (Phase 1-2 통일)
  const exportExcel = ({ year, month, ipFilter = '', selectedIpOption = null, nameQuery = '' }) => triggerAttendanceExcelDownload({
    attendancePath, companyCode, selectedCompanyCodes,
    year, month, ipFilter, selectedIpOption, nameQuery, showToast,
  });

  const openTimeSettings = () => {
    setCompanyModalOpen(true);
    if (!ips && ownIps === null) {
      // 통합 메뉴 달력 탭(2026-09-30): 본사 주소는 통합 열쇠만 가진 사람에게 403 → 근무지 칸이 비었다(합치기 검토)
      const isIntegrated = /\/integrated-menus\/\d+\/attendance$/.test(attendancePath);
      apiClient.get(isIntegrated ? `${attendancePath}/ips` : '/api/admin/ips')
        .then((r) => setOwnIps(r.ok && Array.isArray(r.data) ? r.data : []))
        .catch(() => setOwnIps([]));
    }
  };

  // 모달 영역: 시간 설정(C) — 2026-04-28: companyCodes 필터 적용 (자기 회사만 노출).
  //   PINE 모드 → ['PINE'] / ext 모드 → [companyCode] / 통합 모드(companyCodes 배열) → 그대로
  const modals = (
    <TimeSettingsModalsArea
      ts={ts}
      companyModalOpen={companyModalOpen}
      setCompanyModalOpen={setCompanyModalOpen}
      onEditCompany={(code) => { setActiveSettingsCompany(code); setCompanyModalOpen(false); setPendingOpenSettings(true); }}
      companyCodes={(Array.isArray(companyCodes) && companyCodes.length > 0) ? companyCodes : [companyCode || 'PINE']}
      ipAliases={ips || ownIps || []}
      timeSettingsPathBuilder={timeSettingsPathBuilder}
    />
  );

  return { exportExcel, openTimeSettings, modals };
}
